<template>
  <div class="k-page">
    <el-header>
      <the-header />
    </el-header>

    <el-container class="k-page__main-container">
      <!-- BEGIN: Боковая панель -->
      <el-aside class="k-page__main-sidebar">
        <the-main-menu />
      </el-aside>
      <!-- END: Боковая панель -->

      <!-- BEGIN: Основное окно -->
      <el-container class="k-page__content-container">
        <slot />
      </el-container>
      <!-- END: Основное окно -->
    </el-container>
  </div>
</template>

<script>
/**
 * Component: Шаблон внутреней страницы приложения
 *
 * @version 1.0.0
 */


// Components
import TheHeader from '@/components/TheHeader.vue';
import TheMainMenu from '@/components/TheMainMenu.vue';

export default {
  name: 'k-page',

  components: {
    TheHeader,
    TheMainMenu,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-page {
  position: relative;
  height: 100%;
  min-height: 100%;

  &__main-container {
    min-height: 100%;
  }

  &__main-sidebar {
    min-height: calc(100vh - 60px);
  }

  &__content-container {
    display: flex;
    flex-direction: column;
    padding: $vp $hp;
  }
}
</style>
